import { GetBumpOptionsArgs } from 'types/api/arguments/get-bump-options-args'
import { BumpOptionResp } from 'types/api/response/bump-option-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getBumpOptions = ({ itemIds }: GetBumpOptionsArgs) =>
  api.get<BumpOptionResp>('/push_ups/options', {
    params: { item_ids: itemIds },
    headers: moneyObjectHeader,
  })
